export default "__VITE_PUBLIC_ASSET__4b22b00e__"